import { Form as SemanticForm, Modal as SemanticModal } from 'semantic-ui-react';
import styled, { css } from 'styled-components';

import {
  Button as ButtonLayoutComponent,
  Loader as LoaderLayoutComponent, Text as TextLayoutComponent,
  Checkbox as CheckboxLayoutComponent,
} from '@playbookux/playbook-web-core';

export const Container = styled.div`
  margin-top: 5px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
`;

export const ContainerTesterName = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 265px;
  width: 100%;
`;

export const HeaderContainer = styled.div`
  width: 350px;
  display: inline-block;
`;

export const ButtonContainer = styled.div`
  display: inline-block;
`;

export const RemoveButton = styled(ButtonLayoutComponent.Inverted)`
  &.ui.button {
    margin-left: 20px;
    width: 100px;
  }
`;

export const OtherDetails = styled(TextLayoutComponent.Bold)`
  margin-bottom: 10px;
`;

export const Detail = styled(TextLayoutComponent)`
  margin-bottom: 5px;
`;

export const Loader = styled(LoaderLayoutComponent)``;

export const Tester = styled.div`
  display: flex;
  align-items: center;
  margin: 15px 0px;
`;

export const TesterName = styled(TextLayoutComponent.Bold)`
  min-width: 120px;
  max-width: 265px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${({ hasMeetingUrl }) => css`
      cursor: ${hasMeetingUrl ? 'pointer' : 'auto'};
  `}
`;

export const TesterEmail = styled(TextLayoutComponent)`
  min-width: 120px;
  max-width: 265px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
`;

export const TestDate = styled(TextLayoutComponent.Bold)`
  display: flex;
  min-width: 165px;
  max-width: 265px;
  padding-left: 15px;
  padding-right: 15px;
`;

export const Form = styled(SemanticForm)`
  &.ui.form .fields {
    margin: 0px;
  }
`;

export const InsertError = styled(TextLayoutComponent.Span)`
  color: ${(props) => props.theme.color.textError};
  margin-left: 20px;
`;

export const Button = styled(ButtonLayoutComponent)`
  &.ui.button {
    margin-top: 20px;
  }
`;

export const ActionsContainer = styled.div`
  padding: 10px 0;
`;

export const Modal = styled(SemanticModal)`
  padding: 30px;
`;

export const ModalText = styled.p`
  margin-bottom: 20px;
  font-size: 16px;
  ${({ theme }) => css`
    color: ${theme.color.text}
  `}
`;

export const ModalHeader = styled.p`
  margin-bottom: 20px;
  font-size: 16px;
  ${({ theme }) => css`
    color: ${theme.color.text}
  `}
`;

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 5px;
`;

export const ModalButton = styled(ButtonLayoutComponent)`
    min-width: 100px;
`;

export const Link = styled.a``;

export const ContainerCheckbox = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CheckboxContent = styled.div`
  margin-top: 8px;
`;

export const Checkbox = styled(CheckboxLayoutComponent).attrs(({ theme }) => ({ color: `${theme.color.textSecondary} !important` }))``;

export const ContainerSpace = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ContainerParticipants = styled.div`
  display: flex;
`;
